import { z } from 'zod';

export const schemaChatMessageDeliveredPayload = z.object({
    metaMessageId: z.string().min(1),
});

export type Schema_ChatMessageDeliveredPayload = z.infer<typeof schemaChatMessageDeliveredPayload>;
